import styled from "styled-components";

import Button from "core/Button";

export const ToolbarButton = styled(Button).attrs({
    size: "sm",
    styleType: "outline"
})``;
